/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};

(function ($) {
  'use strict';
  /**
   * Хэлпер для позиционирования попапов.
   */
  app.helpers.PopupPositioningHelper = {
    /**
     * Стандартный верхний отступ от инициатора.
     * @type {number} - отступ в px.
     */
    COMMON_TOP_MARGIN: 12,

    /**
     * Выравнивание по центру инициатора,
     * @param {jQuery} $popup
     * @param {jQuery} $opener
     * @return {Object} css координаты для позиционирования попапа
     */
    positionCenterOfOpener: function ($popup, $opener) {
      var openerOffset = $opener.offset() || { left: 0, top: 0 },
        leftOffset = openerOffset.left + $opener.outerWidth() / 2 - $popup.outerWidth() / 2,
        topOffset = openerOffset.top + $opener.innerHeight() + 10,
        css;
      if (!app.isDesktop) {
        var bodyPosition = $('body').position() || { left: 0, top: 0 };
        leftOffset = leftOffset - bodyPosition.left;
        topOffset = topOffset - bodyPosition.top;
      }
      css = {
        left: leftOffset,
        top: topOffset,
      };
      $popup.css(css);
    },

    /**
     * Расчитывает положение попапа по левому краю инициатора
     * @param {jQuery} $opener - элемент инициатора
     * @param {jQuery} $popup - элемент попапа
     * @param {boolean} withoutTopMargin - с отсупом сверху от инициатора
     * @returns {Object} - обьект с позициями слева и сверху от инициатора.
     */
    positionLeftOfOpener: function ($opener, $popup, withoutTopMargin) {
      var body = $('body'),
        offset = typeof $opener.offset === 'function' ? $opener.offset() : null,
        position = typeof body.position === 'function' ? body.position() : null,
        popupWidth = $popup.outerWidth(),
        leftPos = offset ? offset.left : 0,
        topPos = offset ? offset.top + $opener.innerHeight() + this.COMMON_TOP_MARGIN : 0,
        windowWidth = $(window).width();

      if (!app.isDesktop && position) {
        leftPos = leftPos - position.left;
      }

      if (withoutTopMargin) {
        topPos -= this.COMMON_TOP_MARGIN;
      }

      // если попап слишком далеко от левого края окна, выравниваем его по центру
      if (popupWidth + leftPos > windowWidth) {
        leftPos = (windowWidth - popupWidth) / 2;
      }
      return {
        left: leftPos,
        top: topPos,
      };
    },

    /**
     * Выравнивание по центру окна.
     */
    positionCenterOfWindow: function ($popup) {
      var css =  {
        left: '50%',
        top: '50%',
        'margin-left': -($popup.outerWidth()/2),
        'margin-top': $(window).scrollTop()-($popup.outerHeight()/2),
      };
      $popup.css(css);
    },
  };

})(jQuery);

}.call(window));